function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArtboard9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 57.89297,
    height: 62.98649,
    viewBox: "0 0 57.89297 62.98649",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M55.89391,40.99018V21.99018c-.00095-3.74913-2.00232-7.21286-5.25-9.086L34.19292,3.40419c-3.24673-1.87498-7.24725-1.87498-10.49399,0L7.24794,12.90419c-3.24683,1.87408-5.24704,5.33813-5.24701,9.08701v19c-.00003,3.74887,2.00018,7.21292,5.24701,9.08701l16.45099,9.5c3.24673,1.87498,7.24725,1.87498,10.49399,0l16.45099-9.5c3.24683-1.87408,5.24704-5.33813,5.24701-9.08701",
    style: {
      fill: "#6c86f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "M55.89297,40.99224V21.99224c-.00095-3.74913-2.00232-7.21286-5.25-9.086L34.19199,3.40624c-3.24673-1.87498-7.24725-1.87498-10.49399,0L7.24701,12.90624c-3.24683,1.87408-5.24704,5.33813-5.24701,9.08701v19c-.00003,3.74887,2.00018,7.21292,5.24701,9.08701l16.45099,9.5c3.24673,1.87498,7.24725,1.87498,10.49399,0l16.45099-9.5c3.24829-1.8735,5.24979-5.33817,5.25-9.08801Z",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: 4
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "M25.91785,22.08518c-.11438,.0304-.22583,.07089-.33301,.121l-.12097,.061v.66599c.03003,.36301,.12097,4.38599,.21198,8.95401,.151,6.867,.18201,8.349,.242,8.5,.04504,.20636,.17749,.38297,.36298,.48401,.11499,.07925,.25586,.11179,.39398,.091,.13428,.01221,.26947-.00836,.39398-.06,.26514-.19861,.49097-.44479,.66602-.72601,.47638-.5762,1.03821-1.07602,1.66602-1.48199,1.03003-.81699,1.33301-1.05899,1.78699-1.48199,.71704-.64951,1.16089-1.54691,1.242-2.51099,.03339-.78122-.17853-1.55328-.60602-2.20801-.21307-.28848-.46826-.54333-.75702-.75601-.40582-.23007-.86664-.34518-1.33301-.33301-.58228,.02518-1.15149,.1803-1.66602,.45401-.28522,.12073-.5506,.28391-.78699,.48401l-.21198,.181v-.36002c0-.21201,.06097-2.48099,.12097-5.082,.03003-2.60001,.091-4.71899,.091-4.74899,0-.121-.54498-.29999-.909-.29999-.15295,.0051-.30499,.02518-.45398,.06m3.362,10.79999c.53339,.39685,.83887,1.02951,.81799,1.694,.00183,.97049-.35419,1.90756-1,2.63199-.50458,.59409-1.06226,1.14102-1.66602,1.634,0-.03-.06-.242-.091-.51401-.08008-1.39188-.04962-2.78793,.091-4.17499,.09912-.45044,.3454-.85507,.70001-1.14999,.34357-.21832,.76953-.26309,1.151-.121",
    style: {
      fill: "#4f61b3"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtboard9);
export default __webpack_public_path__ + "static/media/Artboard_9.9170ed727f1f8f2273256e6c5c07d5ae.svg";
export { ForwardRef as ReactComponent };